// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "a.disabled .b-icon.bi[data-v-039b5656]{cursor:auto;color:var(--breadcrumbIconFont)}", ""]);
// Exports
module.exports = exports;
